import React, { Component } from 'react';
import CacheKeys from '../../../cache/CacheKeys';
import CacheManager from '../../../cache/CacheManager';
import MonitoringIntelligenceRetailUI from './MonitoringIntelligenceRetailUI';
import { withRouter } from 'react-router-dom';
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils";

class MonitoringIntelligenceRetailSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorList: null,
      chequeBounceList: null,
      filteredChequeBounceList: null,
      selectedStatus: 'all',
      searchFilter: '',
      loading: false,
      downloadSubmitted: false,
      isUpdateMode: false,
      currentItem: null,
      processedData: [],
      isEmiDetailsModalOpen: false,
      currentEmiDetails: null,
      isAccountSummaryOpen: false,
      currentAccountSummary: null,
      messageApprovalList: [],
      isNoticeModalOpen: false,
      noticeModalType: null, // 'whatsapp' or 'email'
      noticeModalAccountId: null,
      noticeCreationLoading: false,
      nonFinancialComplianceData: {}
    };
  }

  render() {
    return (
      <MonitoringIntelligenceRetailUI
        context={this.props.context}
        errorList={this.state.errorList}
        chequeBounceList={this.state.filteredChequeBounceList}
        processedData={this.state.processedData}
        yearMonth={this.state.yearMonth}
        onPreviousClick={this.onPreviousClick}
        onNextClick={this.onNextClick}
        onRefreshClick={this.onRefreshClick}
        selectedStatus={this.state.selectedStatus}
        selectedReportType={this.state.selectedReportType}
        onStatusChange={this.onStatusChange}
        onReportTypeChange={this.onReportTypeChange}
        searchFilter={this.state.searchFilter}
        lrnFilter={this.state.lrnFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        onLrnFilterChange={this.onLrnFilterChange}
        onDownloadReport={this.onDownloadReport}
        getStatusDisplayValue={this.getStatusDisplayValue}
        onDocDownloadClick={this.onDocDownloadClick}
        isUpdateMode={this.state.isUpdateMode}
        onUpdateMode={this.onUpdateMode}
        onUpdateModeClose={this.onUpdateModeClose}
        currentItem={this.state.currentItem}
        onEmiDetailsClick={this.onEmiDetailsClick}
        closeEmiDetailsModal={this.closeEmiDetailsModal}
        isEmiDetailsModalOpen={this.state.isEmiDetailsModalOpen}
        currentEmiDetails={this.state.currentEmiDetails}
        setOpenPenalClauseDialog={this.setOpenPenalClauseDialog}
        closePenalClauseModal={this.closePenalClauseModal}
        isPenalClauseModalOpen={this.state.isPenalClauseModalOpen}
        currentPenalClauses={this.state.currentPenalClauses}
        onCreateWhatsappApproval={this.openWhatsappNoticeModal}
        onCreateEmailApproval={this.openEmailNoticeModal}
        onViewAccountSummary={this.onViewAccountSummary}
        isAccountSummaryOpen={this.state.isAccountSummaryOpen}
        currentAccountSummary={this.state.currentAccountSummary}
        closeAccountSummaryModal={this.closeAccountSummaryModal}
        messageApprovalList={this.state.messageApprovalList}
        onLegalChargeDetailsClick={this.onLegalChargeDetailsClick}
        closeLegalDetailsModal={this.closeLegalDetailsModal}
        isLegalDetailsModalOpen={this.state.isLegalDetailsModalOpen}
        currentLegalDetails={this.state.currentLegalDetails}
        onPenalChargeDetailsClick={this.onPenalChargeDetailsClick}
        closePenalDetailModal={this.closePenalDetailModal}
        isPenalDetailModalOpen={this.state.isPenalDetailModalOpen}
        currentPenalDetails={this.state.currentPenalDetails}
        onDsraShortfallDetailsClick={this.onDsraShortfallDetailsClick}
        closeDsraDetailModal={this.closeDsraDetailModal}
        isDsraDetailModalOpen={this.state.isDsraDetailModalOpen}
        currentDsraDetails={this.state.currentDsraDetails}
        setOpenDsraClauseDialog={this.setOpenDsraClauseDialog}
        closeDsraClauseModal={this.closeDsraClauseModal}
        isDsraClauseModalOpen={this.state.isDsraClauseModalOpen}
        currentDsraClause={this.state.currentDsraClause}
        // New notice modal props
        isNoticeModalOpen={this.state.isNoticeModalOpen}
        onOpenNoticeModal={this.onOpenNoticeModal}
        onCloseNoticeModal={this.onCloseNoticeModal}
        onCreateNoticeDraft={this.onCreateNoticeDraft}
        noticeModalType={this.state.noticeModalType}
        noticeModalAccountId={this.state.noticeModalAccountId}
        noticeCreationLoading={this.state.noticeCreationLoading}
        nonFinancialComplianceData={this.state.nonFinancialComplianceData}
      />
    );
  }

  componentDidMount() {
    this.getMonitoringIntelligenceReport(this.props.context, '', '');
  }

  onOpenNoticeModal = (accountId, messageType) => {
    this.setState({
      isNoticeModalOpen: true,
      noticeModalType: messageType,
      noticeModalAccountId: accountId
    });
  };

  onCloseNoticeModal = () => {
    this.setState({
      isNoticeModalOpen: false,
      noticeModalType: null,
      noticeModalAccountId: null
    });
  };

  onCreateNoticeDraft = (accountId, noticeType, messageType) => {
    this.setState({ noticeCreationLoading: true });

    const apiEndpoint = messageType === 'whatsapp'
      ? `/api/su/monitoringIntelligence/accounts/${accountId}/notice/${noticeType}/createWhatsappMessageApproval`
      : `/api/su/monitoringIntelligence/accounts/${accountId}/notice/${noticeType}/createEmailApproval`;

    RestApiUtils.post(
      this.props.context,
      apiEndpoint,
      this.onCreateNoticeDraftCallback,
      {},
      null
    );
  };

  onCreateNoticeDraftCallback = (response) => {
    this.setState({ noticeCreationLoading: false });

    if (response.errorList && response.errorList.length > 0) {
      alert(`Error: ${response.errorList[0].message}`);
    } else {
      const messageTypeText = this.state.noticeModalType === 'whatsapp' ? 'WhatsApp' : 'Email';
      alert(`${messageTypeText} notice draft created successfully`);
      this.onCloseNoticeModal();
      this.onRefreshClick();
    }
  };
  openWhatsappNoticeModal = (accountId) => {
    this.onOpenNoticeModal(accountId, 'whatsapp');
  };

  openEmailNoticeModal = (accountId) => {
    this.onOpenNoticeModal(accountId, 'email');
  };

  onViewAccountSummary = (accountName, summaryData) => {
    this.setState({
      isAccountSummaryOpen: true,
      currentAccountSummary: {
        accountName,
        loanSummaries: summaryData.loanSummaries,
        accountSummary: summaryData.accountSummary
      }
    });
  };

  closeAccountSummaryModal = () => {
    this.setState({
      isAccountSummaryOpen: false,
      currentAccountSummary: null
    });
  };

  onEmiDetailsClick = (details) => {
    this.setState({
      isEmiDetailsModalOpen: true,
      currentEmiDetails: details
    });
  };

  closeEmiDetailsModal = () => {
    this.setState({
      isEmiDetailsModalOpen: false,
      currentEmiDetails: null
    });
  };
  onLegalChargeDetailsClick = (details) => {
    this.setState({
      isLegalDetailsModalOpen: true,
      currentLegalDetails: details
    });
  };

  closeLegalDetailsModal = () => {
    this.setState({
      isLegalDetailsModalOpen: false,
      currentLegalDetails: null
    });
  };
  onPenalChargeDetailsClick = (details) => {
    this.setState({
      isPenalDetailModalOpen: true,
      currentPenalDetails: details
    });
  };

  closePenalDetailModal = () => {
    this.setState({
      isPenalDetailModalOpen: false,
      currentPenalDetails: null
    });
  };
  onDsraShortfallDetailsClick = (details) => {
    this.setState({
      isDsraDetailModalOpen: true,
      currentDsraDetails: details
    });
  };

  closeDsraDetailModal = () => {
    this.setState({
      isDsraDetailModalOpen: false,
      currentDsraDetails: null
    });
  };

  setOpenPenalClauseDialog = (defaultReason) => {
    this.setState({
      isPenalClauseModalOpen: true,
      currentPenalClauses: defaultReason
    });
  };

  closePenalClauseModal = () => {
    this.setState({
      isPenalClauseModalOpen: false,
      currentPenalClauses: null
    });
  };
  setOpenDsraClauseDialog = (defaultReason) => {
    this.setState({
      isDsraClauseModalOpen: true,
      currentDsraClause: defaultReason
    });
  };

  closeDsraClauseModal = () => {
    this.setState({
      isDsraClauseModalOpen: false,
      currentDsraClause: null
    });
  };


  processChequeData = (data) => {
    if (!data || !data.monitoringIntelligenceList) return { processedData: [], nonFinancialComplianceData: {} }

    let processedData = []
    let serialCounter = 1
    let currentAccountId = null
    let processedDsraAccounts = new Set()
    let nonFinancialComplianceData = {}

    data.monitoringIntelligenceList.forEach(account => {
      if (currentAccountId !== account.accountId) {
        currentAccountId = account.accountId
        if (processedData.length > 0) {
          serialCounter++
        }
      }
      // Process non-financial compliance data
      if (account.loans && account.loans.length > 0) {
        account.loans.forEach(loan => {
          if (loan.nonFinancialCompliances && loan.nonFinancialCompliances.length > 0) {
            if (!nonFinancialComplianceData[account.accountName]) {
              nonFinancialComplianceData[account.accountName] = []
            }

            loan.nonFinancialCompliances.forEach(compliance => {
              nonFinancialComplianceData[account.accountName].push({
                ...compliance,
                lrn: loan.lrn,
                loanId: loan.loanId,
                accountId: account.accountId
              })
            })
          }
        })
      }

      if (account.loans && account.loans.length > 0) {
        account.loans.filter(loan => loan.loanType === "retail").forEach(loan => {
          if (loan.chequeData && loan.chequeData.length > 0) {
            loan.chequeData.forEach((item, index) => {
              processedData.push({
                serialNumber: serialCounter,
                accountName: account.accountName,
                isFirstInAccount: index === 0 && (!processedData.some(entry =>
                  entry.accountName === account.accountName)),
                isAccountLevel: false,
                item: {
                  ...item,
                  loanId: loan.loanId,
                  lrn: loan.lrn,
                  accountId: account.accountId
                }
              })
            })
          }

          if (loan.legalChargeData && loan.legalChargeData.length > 0) {
            loan.legalChargeData.forEach((item, index) => {
              processedData.push({
                serialNumber: serialCounter,
                accountName: account.accountName,
                isFirstInAccount: index === 0 && (!processedData.some(entry =>
                  entry.accountName === account.accountName)),
                isAccountLevel: false,
                item: {
                  ...item,
                  loanId: loan.loanId,
                  lrn: loan.lrn || 'N/A',
                  accountId: account.accountId
                }
              })
            })
          }

          if (loan.penalChargeData && loan.penalChargeData.length > 0) {
            loan.penalChargeData.forEach((item, index) => {
              processedData.push({
                serialNumber: serialCounter,
                accountName: account.accountName,
                isFirstInAccount: index === 0 && (!processedData.some(entry =>
                  entry.accountName === account.accountName)),
                isAccountLevel: false,
                item: {
                  ...item,
                  loanId: loan.loanId,
                  lrn: loan.lrn || 'N/A',
                  accountId: account.accountId
                }
              })
            })
          }

          if (loan.emiData && loan.emiData.length > 0) {
            loan.emiData.forEach((item, index) => {
              processedData.push({
                serialNumber: serialCounter,
                accountName: account.accountName,
                isFirstInAccount: index === 0 && (!processedData.some(entry =>
                  entry.accountName === account.accountName)),
                isAccountLevel: false,
                item: {
                  ...item,
                  loanId: loan.loanId,
                  lrn: loan.lrn || 'N/A',
                  accountId: account.accountId,
                  closureStatus: item.closureStatus || 'N/A',
                  overdueInterest: item.overdueInterest || 'N/A',
                  lastPaymentDate: item.lastPaymentDate || 'N/A',
                  defaultDate: item.defaultDate || 'N/A',
                  cureDate: item.cureDate || 'N/A',
                  defaultReason: item.defaultReason || 'N/A',
                  fileUploadList: item.fileUploadList || [],
                  details: item.details || []
                }
              })
            })
          }
        })
      }

      if (account.nachFailData && account.nachFailData.length > 0) {
        account.nachFailData.forEach((item, index) => {
          processedData.push({
            serialNumber: serialCounter,
            accountName: account.accountName,
            isFirstInAccount: index === 0 && (!processedData.some(entry =>
              entry.accountName === account.accountName)),
            isAccountLevel: true,
            item: {
              ...item,
              accountId: account.accountId
            }
          })
        })
      }

      if (account.dsraShortFall && account.dsraShortFall.length > 0) {
        account.dsraShortFall.forEach((item, index) => {
          if (processedDsraAccounts.has(item.accountId)) {
            return
          }

          processedData.push({
            serialNumber: serialCounter,
            accountName: account.accountName,
            isFirstInAccount: index === 0 && (!processedData.some(entry =>
              entry.accountName === account.accountName)),
            isAccountLevel: true,
            item: {
              ...item,
              accountId: account.accountId,
              amount: item.dsra,
              amountReceived: item.dsraCur,
              amountPending: item.dsraDip
            }
          })

          processedDsraAccounts.add(item.accountId)
        })
      }
    })

    return { processedData, nonFinancialComplianceData }
  }

  onPreviousClick = () => {
    let context = this.props.context
    this.getMonitoringIntelligenceReport(context, this.state.previousYear, this.state.previousMonth)
  }

  onNextClick = () => {
    let context = this.props.context
    this.getMonitoringIntelligenceReport(context, this.state.nextYear, this.state.nextMonth)
  }

  getMonitoringIntelligenceReport = (context = this.props.context, year, month) => {
    this.setState({ loading: true });
    year = year === undefined ? '' : year
    month = month === undefined ? '' : month

    let cacheManager = new CacheManager({
      resource: '/api/su/monitoringIntelligence',
      cacheKey: CacheKeys.ChequeBouncesList(year, month),
      callback: this.getChequeBounceCallback,
      ttlInSecs: 600,
    });
    cacheManager.getObject2(context, {}, { year: year, month: month });
  };

  getChequeBounceCallback = (response) => {
    const chequeBounceList = response.monitoringIntelligenceList || [];
    const { processedData, nonFinancialComplianceData } = this.processChequeData(response);
    const messageApprovalList = response.messageApprovalList || [];

    this.setState({
      chequeBounceList: chequeBounceList,
      filteredChequeBounceList: chequeBounceList,
      processedData: processedData,
      nonFinancialComplianceData: nonFinancialComplianceData,
      messageApprovalList: messageApprovalList,
      errorList: response.errorList || [],
      loading: false,
      yearMonth: response.yearMonth,
      year: response.yearMonth.year,
      month: response.yearMonth.month,
      previousYear: response.yearMonth.prevYear,
      previousMonth: response.yearMonth.prevMonth,
      nextYear: response.yearMonth.nextYear,
      nextMonth: response.yearMonth.nextMonth
    }, this.applyFilters);
  };

  onDownloadReport = () => {
    let context = this.props.context;
    this.setState({ downloadSubmitted: true });
  };

  getDownloadReportCallback = (response) => {
    this.setState({ downloadSubmitted: false });
  };

  onStatusChange = (selectedOption) => {
    this.setState({ selectedStatus: selectedOption.value }, this.applyFilters);
  };
  onReportTypeChange = (selectedOption) => {
    this.setState({ selectedReportType: selectedOption.value }, this.applyFilters);
  };

  onSearchFilterChange = (event) => {
    const searchFilter = event.target.value;
    this.setState({ searchFilter }, this.applyFilters);
  };
  onLrnFilterChange = (event) => {
    const lrnFilter = event.target.value;
    this.setState({ lrnFilter }, this.applyFilters);
  };

  onDocDownloadClick = (event) => {
    const loanId = event.currentTarget.getAttribute('data-loan-id');
    const fileName = event.currentTarget.getAttribute('data-file-name');

    this.setState({ downloadSubmitted: true });

    RestApiUtils.get(
      this.props.context,
      `/api/su/loans/${loanId}/${fileName}/fileDownloadSignedUrl`,
      this.onDocDownloadClickCallback,
      null
    );
  };

  onDocDownloadClickCallback = (response) => {
    this.setState({
      downloadSubmitted: false,
      errorList: response.errorList || []
    });

    if (
      response.errorList.length === 0 &&
      response.signedUrl &&
      response.signedUrl.signedUrl
    ) {
      var link = document.createElement('a');
      link.href = response.signedUrl.signedUrl;
      link.download = '';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  onUpdateMode = (item) => {
    this.setState({
      isUpdateMode: true,
      currentItem: item
    });
  };

  onUpdateModeClose = () => {
    this.setState({
      isUpdateMode: false,
      currentItem: null
    });
  };

  applyFilters = () => {
    const { chequeBounceList, selectedStatus, selectedReportType, searchFilter, lrnFilter } = this.state;

    if (!chequeBounceList) return;

    let filteredList = JSON.parse(JSON.stringify(chequeBounceList));

    filteredList = filteredList.filter(accountData => {
      const searchLower = searchFilter ? searchFilter.toLowerCase() : '';
      const lrnLower = lrnFilter ? lrnFilter.toLowerCase() : '';

      if (searchLower && accountData.accountName && !accountData.accountName.toLowerCase().includes(searchLower)) {
        return false;
      }

      if (lrnLower) {
        const hasMatchingLrn = accountData.loans &&
          accountData.loans.some(loan =>
            loan.lrn && loan.lrn.toLowerCase().includes(lrnLower)
          );

        if (!hasMatchingLrn) {
          return false;
        }
      }

      if (accountData.loans && accountData.loans.length > 0) {
        accountData.loans = accountData.loans.filter(loan =>
          loan.loanType === "retail"
        );

        if (accountData.loans.length === 0) {
          return false;
        }
      }

      if (selectedReportType && selectedReportType !== 'all') {
        const hasReportTypeData = {
          nachFailure: accountData.nachFailData && accountData.nachFailData.length > 0,
          legalCharge: accountData.loans && accountData.loans.some(loan => loan.legalChargeData && loan.legalChargeData.length > 0),
          penalCharge: accountData.loans && accountData.loans.some(loan => loan.penalChargeData && loan.penalChargeData.length > 0),
          emi: accountData.loans && accountData.loans.some(loan => loan.emiData && loan.emiData.length > 0),
          chequeBounce: accountData.loans && accountData.loans.some(loan => loan.chequeData && loan.chequeData.length > 0),
          dsraShortfall: accountData.dsraShortFall && accountData.dsraShortFall.length > 0
        };

        if (!hasReportTypeData[selectedReportType]) {
          return false;
        }

        if (selectedReportType !== 'nachFailure') {
          accountData.nachFailData = [];
        }

        if (selectedReportType !== 'dsraShortfall') {
          accountData.dsraShortFall = [];
        }

        if (accountData.loans && accountData.loans.length > 0) {
          accountData.loans = accountData.loans.map(loan => {
            if (selectedReportType !== 'chequeBounce') loan.chequeData = [];
            if (selectedReportType !== 'legalCharge') loan.legalChargeData = [];
            if (selectedReportType !== 'penalCharge') loan.penalChargeData = [];
            if (selectedReportType !== 'emi') loan.emiData = [];

            return loan;
          }).filter(loan =>
            (selectedReportType === 'chequeBounce' && loan.chequeData && loan.chequeData.length > 0) ||
            (selectedReportType === 'legalCharge' && loan.legalChargeData && loan.legalChargeData.length > 0) ||
            (selectedReportType === 'penalCharge' && loan.penalChargeData && loan.penalChargeData.length > 0) ||
            (selectedReportType === 'emi' && loan.emiData && loan.emiData.length > 0)
          );
        }
      }

      if (accountData.loans && accountData.loans.length > 0) {
        accountData.loans = accountData.loans.map(loan => {
          ['chequeData', 'legalChargeData', 'penalChargeData', 'emiData'].forEach(key => {
            if (loan[key] && loan[key].length > 0 && selectedStatus !== 'all') {
              loan[key] = loan[key].filter(item =>
                item.closureStatus && item.closureStatus.toLowerCase() === selectedStatus.toLowerCase()
              );
            }
          });
          return loan;
        }).filter(loan =>
          (loan.chequeData && loan.chequeData.length > 0) ||
          (loan.legalChargeData && loan.legalChargeData.length > 0) ||
          (loan.penalChargeData && loan.penalChargeData.length > 0) ||
          (loan.emiData && loan.emiData.length > 0)
        );
      }

      if (accountData.nachFailData && accountData.nachFailData.length > 0 && selectedStatus !== 'all') {
        accountData.nachFailData = accountData.nachFailData.filter(item =>
          item.closureStatus && item.closureStatus.toLowerCase() === selectedStatus.toLowerCase()
        );
      }

      if (accountData.dsraShortFall && accountData.dsraShortFall.length > 0 && selectedStatus !== 'all') {
        accountData.dsraShortFall = accountData.dsraShortFall.filter(item =>
          item.closureStatus && item.closureStatus.toLowerCase() === selectedStatus.toLowerCase()
        );
      }

      return (
        (accountData.loans && accountData.loans.length > 0) ||
        (accountData.nachFailData && accountData.nachFailData.length > 0) ||
        (accountData.dsraShortFall && accountData.dsraShortFall.length > 0)
      );
    });

    this.setState({
      filteredChequeBounceList: filteredList,
      processedData: this.processChequeData({ monitoringIntelligenceList: filteredList }).processedData
    });
  };

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.ChequeBouncesList(this.state.year, this.state.month));
    this.setState({
      filteredChequeBounceList: null,
      errorList: null,
      selectedStatus: 'all',
      searchFilter: '',
      processedData: []
    }, () => {
      this.getMonitoringIntelligenceReport(this.props.context, this.state.year, this.state.month);
    });
  };

  getStatusDisplayValue = (statusKey) => {
    let closureStatusList = [
      { key: 'open', value: 'Open' },
      { key: 'close', value: 'Close' },
      { key: 'pending_for_closure', value: 'Pending For Closure' }
    ]
    const statusItem = closureStatusList.find(item => item.key === statusKey)
    return statusItem ? statusItem.value : statusKey
  }
}

export default withRouter(MonitoringIntelligenceRetailSF);